import { BusinessSignedListResolver } from './services/declaration-of-conformity.resolver.service';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AppSharedModule } from './../shared/appShared.module';
import { DeclarationConformityServices } from './services/declaration-conformity.service';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { DeclarationOfConformityComponent } from './declaration-of-conformity.component';
import { DeclarationConformityComponent } from './components/declaration-conformity.component';
import { CommonModule } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { DatePickerModule } from 'primeng/datepicker';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';

@NgModule({
    imports: [
        AppSharedModule,
        RouterModule,
        TranslatePipe, TranslateDirective,
        CommonModule,
        ConfirmDialogModule,
        ToggleSwitchModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        DatePickerModule,
        TableModule,
        DialogModule,
        ToggleSwitchModule
    ],
    exports: [DeclarationOfConformityComponent, DeclarationConformityComponent],
    declarations: [
        DeclarationOfConformityComponent,
        DeclarationConformityComponent
    ],
    providers: [DeclarationConformityServices, BusinessSignedListResolver]
})
export class DeclarationOfConformityModule {}
